import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders  } from "@angular/common/http";
import {Observable, map} from 'rxjs';
import { GlobalconfigService } from '../common/globalConfig.service';



@Injectable()
export class NewPackageService {
   
    private baseNewPackageUrl: string = ''
    private baseFusoPackageUrl: string = ''

    constructor(private http: HttpClient, private config: GlobalconfigService){
        this.baseNewPackageUrl = this.config.baseApiUrl + "packageMaster";
        this.baseFusoPackageUrl = this.config.baseApiUrl + "fusoPackageMaster";
    }
  

    getAllPackage(): Observable<any>{
        let userDetails = localStorage.getItem('userDetails');
        let userDetJson = JSON.parse(userDetails);
        let userRoleId = userDetJson.userRoleMappings[0].roleId;

        let userSuppCode:any[] = userDetJson.supplierCode;
       

        console.log('supplier code len==>'+userSuppCode.length);

        

        let suppCode = userSuppCode.toString();
        if(userSuppCode.length>1){
           return this.http.post(this.config.baseApiUrl+'/fetchPackageMaster', userSuppCode);
           
        }
        return this.http.get(this.baseNewPackageUrl+'/allStatus/'+ suppCode)
    }

      getAllNewPackage(): Observable<any> {
        let userDetails = localStorage.getItem('userDetails');
        let userDetJson = JSON.parse(userDetails);
        let userRoleId = userDetJson.userRoleMappings[0].roleId;

        let userSuppCode = userDetJson.supplierCode;
        let suppCode = userSuppCode.toString();
        return this.http.get(this.baseNewPackageUrl + '/newStatus/' + suppCode)
    }

    getFusoPackage(): Observable<any>{
        let userDetails = localStorage.getItem('userDetails');
        let userDetJson = JSON.parse(userDetails);
        let loginId = userDetJson.loginId;
        return this.http.get(this.baseFusoPackageUrl +'/userSpecific/' + loginId)
    }

    submitNewPackageData(formData){
    //  let getNewPackageDataUrl = this.config.baseNewPackageUrl + 'newPackage'
    console.log("form data is ==>"+formData);
        return this.http.post(this.baseNewPackageUrl, formData )
    }

    submitFusoPackageData(fusoData){
        return this.http.post(this.baseFusoPackageUrl, fusoData)
    }

    checkPackageCodeAvailiblity(packageId){
        return this.http.get(this.baseNewPackageUrl +'/'+ packageId)
    }

   getFusoPackageCodeById(fusoPkgId){
        return this.http.get(this.baseFusoPackageUrl + '/' + fusoPkgId)
   }

   updatePkgStatus(statusData){
       return this.http.post(this.baseNewPackageUrl + '/updatePackageCodeStatus', statusData)
   }

  getApprovedPkgCode(){
      return this.http.get(this.baseNewPackageUrl + '/approvedStatus')
  }

getFusoPkgCode(){
    return this.http.get(this.baseFusoPackageUrl)
}

getSMpackages(){
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    let loginId = userDetJson.loginId;
    return this.http.get(this.baseNewPackageUrl + '/userSpecific/' + loginId)
}

getAllPackages(){
    return this.http.get(this.baseNewPackageUrl).pipe(map((res : Response)=> res.json()));
}
}